import { render } from "./StripeOauth.vue?vue&type=template&id=5a15baf3"
import script from "./StripeOauth.vue?vue&type=script&lang=js"
export * from "./StripeOauth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__